import { render, staticRenderFns } from "./404.vue?vue&type=template&id=d81777c6&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=d81777c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.98.0__lodash@4._0ede07508368b0c10a5f63bb0b6a47bb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81777c6",
  null
  
)

export default component.exports